<template>
  <div
    class="modal fade"
    id="ModalAddNewBlockIP"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ثبت ip جدید در لیست مسدود شده ها</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2">

          <!-- کادر ip کاربر -->
          <div class="position-relative">
            <input
              type="text"
              placeholder="کاربر ip"
              class="form-control text-center mt-2"
              v-model="NewBlockIPData.UserIP"
              autocomplete="off"
              style="direction: ltr;"
            />
            <i class="fas fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;"></i>
          </div>

          <!-- کادر مدت مسدود شدن -->
          <div class="position-relative">
            <select
              class="form-control mt-1 text-center"
              v-model="NewBlockIPData.BlockIPTime"
            >
              <option value="0">مدت مسدود شدن را انتخاب نمایید</option>
              <option value="5">5 دقیقه</option>
              <option value="10">10 دقیقه</option>
              <option value="15">15 دقیقه</option>
              <option value="60">1 ساعت</option>
              <option value="120">2 ساعت</option>
              <option value="300">5 ساعت</option>
              <option value="600">10 ساعت</option>
              <option value="1440">1 روز</option>
              <option value="2880">2 روز</option>
              <option value="-1">دائمی</option>
            </select>
            <i class="far fa-building fa-1x-half position-absolute" style="right: 9px; top: 33%;"></i>
          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="SaveNewBlockIpData()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ثبت ip جدید
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        NewBlockIPData:{ 
          ID: 0, 
          UserIP: '', 
          BlockDate: '', 
          CountError: 0, 
          BlockIPTime: 0,
          ActiveStatus: true,
        }
        ,
      // کنترل وضعیت اتصال به سرور
      checkConnectToServer: false,
    };
  },
  methods: {
    // ذخیره تغییرات حساب کاربری
    async SaveNewBlockIpData() {
      // آیا آی پی کاربر مقدار دهی شده است ؟
      if(this.NewBlockIPData.UserIP != ''){
        // آیا مدت مسدود شدن ثبت شده است ؟
        if(this.NewBlockIPData.BlockIPTime != 0){
          // اعلام اتصال به سرور
          this.checkConnectToServer = true;
          // دریافت توکن احراز هویت
          let token = await this.$store.getters.getUserData.token;
          // تاریخ ثبت
          // جهت رفع خطای نوع داده تاریخ در ارسال
          this.NewBlockIPData.BlockDate = new Date().toISOString();
          this.NewBlockIPData.ActiveStatus = true;
          // ثبت اطلاعات کاربر در سرور
          var check = await this.$store.dispatch("AddNewBlockIPToServer", {
            NewBlockIPData: this.NewBlockIPData,
            token: token,
          });
          if (check == true){
            // آی پی مورد نظر به لیست اضافه شد
            this.$store.dispatch("notify", {
              notText: "ip مورد نظر با موفقیت به لیست اضافه شد .",
              timeOut: 2500,
            });

            // بستن مودال ثبت آی پی کاربر
            $("#ModalAddNewBlockIP").modal("hide");
          }
        } else {
          // ثبت مدت مسدود شدن الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج مدت مسدود شدن : درج مدت مسدود شدن الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت آی پی کاربر الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج ip : درج ip کاربر الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },

  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ManageBlockIP/Components/AddNewBlockIP.vue